<template>
  <div class="info" ref="info">
    <el-form
      :model="infoForm"
      :rules="rules"
      ref="infoForm"
      label-width="160px"
      class="info-form"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="发函日期：" prop="applyTime">
            <el-date-picker
              class="w-all"
              v-model="infoForm.applyTime"
              type="date"
              placeholder="请选择申请时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业全称：" prop="name">
            <el-input
              v-model="infoForm.name"
              placeholder="请输入企业全称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入会介绍人：" prop="introducePerson">
            <el-input
              v-model="infoForm.introducePerson"
              placeholder="请输入入会介绍人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会费全额：" prop="money">
            <el-input
              v-model="infoForm.money"
              placeholder="请输入会费全额"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人姓名：" prop="contacts">
            <el-input
              v-model="infoForm.contacts"
              placeholder="请输入联系人姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人电话：" prop="contactsPhone">
            <el-input
              v-model="infoForm.contactsPhone"
              placeholder="请输入联系人电话"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="会员分类：" prop="memberType">
            <el-select
              class="w-all"
              v-model="infoForm.memberType"
              placeholder="请选择会员分类"
            >
              <el-option
                v-for="item in memberType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="业务范围(可多选)："
            prop="moreType"
            v-if="infoForm.memberType === 1"
          >
            <el-select
              class="w-all"
              :multiple-limit="6"
              v-model="infoForm.moreType"
              multiple
              placeholder="请选择业务范围"
            >
              <el-option
                v-for="item in supply"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="业务范围(可多选)："
            prop="moreType"
            v-if="infoForm.memberType === 2"
          >
            <el-select
              class="w-all"
              :multiple-limit="6"
              v-model="infoForm.moreType"
              multiple
              placeholder="请选择业务范围"
            >
              <el-option
                v-for="item in demand"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label-width="0">
            <div class="flex align-center justify-around">
              <el-button
                type="primary"
                class="w-20"
                @click="submitForm('infoForm', 1)"
                >提交</el-button
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  demand, introduce, memberType, optionList, supply, zhDate
} from "@/utils/utils";
import rules from "@/utils/rules";
import { perpareAdd, perpareEdit, perpareDetail } from "@/api/admin";

export default {
  name: "info",
  data () {

    return {

      memberType: optionList(false, memberType),
      supply: optionList(false, supply),
      demand: optionList(false, demand),
      introduce: optionList(false, introduce),
      infoForm: {
        applyTime: null,
        name: '',
        introducePerson: '',
        money: '',
        contacts: '',
        contactsPhone: '',
        memberType: '',
        moreType: '',
      },
      rules: {
        applyTime: [{ type: 'date', required: true, message: '请选择申请时间', trigger: 'change' }],
        name: [{ required: true, message: '请输入企业全称', trigger: 'blur' }],
        introducePerson: [{ required: true, message: '请输入入会介绍人', trigger: 'blur' }],
        money: [{ required: true, message: '请输入会费全额', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
        contactsPhone: rules.phone,
        memberType: [{ required: true, message: '请选择会员分类', trigger: 'change' }],
        moreType: [{ required: true, message: '请选择服务类别', trigger: 'change' }],
      },

    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
  },
  created () {
    this.$emit("setIndex", '/admin/prepare', "预备会员  / 编辑", true, 'icon-jibenxinxi1');
    console.log(this.$route.params.id)
    if (Number(this.$route.params.id)) this.getDetail()
  },
  components: {},
  methods: {
    // 获取基本信息
    async getDetail () {
      let _data = await perpareDetail(this.$route.params.id)
      if (_data.data) {
        this.infoForm = {
          applyTime: new Date(_data.data.issue_date),
          name: _data.data.company_name,
          introducePerson: _data.data.introducer_name,
          money: _data.data.amount_fee,
          contacts: _data.data.unit_contact,
          contactsPhone: _data.data.unit_phone,
          memberType: _data.data.member_type?Number(_data.data.member_type):'',
          moreType: _data.data.bussess_scope ?_data.data.bussess_scope.split(',').map(Number):''
        }

      } else {
        this.infoForm.name = this.user.user_name
      }
      this.$nextTick(() => {
        this.$refs.infoForm.clearValidate()
      })
    },
    //  提交
    async sureSubmut () {
      if (Number(this.$route.params.id)) {
        let _state = await perpareEdit(
          this.$route.params.id,
          zhDate(this.infoForm.applyTime),
          this.infoForm.name,
          this.infoForm.introducePerson,
          this.infoForm.money,
          this.infoForm.contacts,
          this.infoForm.contactsPhone,
          this.infoForm.memberType,
          this.infoForm.moreType.join(','),
        )
        if (_state.status === 200) {
          this.$message.success(_state.msg)
          this.$router.go(-1)
        }
      } else {
        let _state = await perpareAdd(
          zhDate(this.infoForm.applyTime),
          this.infoForm.name,
          this.infoForm.introducePerson,
          this.infoForm.money,
          this.infoForm.contacts,
          this.infoForm.contactsPhone,
          this.infoForm.memberType,
          this.infoForm.moreType.join(','),
        )
        if (_state.status === 200) {
          this.$message.success(_state.msg)
          this.$router.go(-1)
        }
      }

    },
    //  提交前验证
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sureSubmut()
        } else {
          this.$message.error('信息填写不完整，请检查修改！')
          this.$nextTick(() => {
            this.$refs.info.scrollTo(0, 0);
          });
        }
      });
    },

  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.info {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  height: calc(100vh - 180px);
  overflow: auto;

  .xieyi {
    font-size: 14px;
    line-height: 24px;
    padding-left: 50px;
    color: #666;

    p {
      text-indent: 32px;
    }
  }

  .agree {
    width: 220px;
    margin: 0 auto;
  }
}
</style>